import React from 'react';
//import PropTypes from 'prop-types';
import { Row, Col, Label } from 'reactstrap';
import {  selectThemeColors } from '@utils';
import SelectOptions from '@components/input/SelectOptions';


function CheckListComponent({ values, setFieldValue }) {  
  //const [answers, setAnswers] = useState([]);
  return (
    <Row lg={12} className="mb-1">
      <Col lg={5}>
        <Label htmlFor="friends" className="label-road-input">
          Lista
        </Label>       
        <SelectOptions
                theme={selectThemeColors}               
                options={values.map((tag) => ({ label:tag, value:tag }))}
                setOptions={ (dat) => { setFieldValue('list', dat.map((item) => item.label)); }}
              />
      </Col>
    </Row>
  );
}

export default CheckListComponent;
